const CODE_EXTENSIONS = new Set([
  '.sql', '.py', '.js', '.ts', '.jsx', '.tsx', '.json', '.yml', '.yaml',
  '.sh', '.bash', '.jinja', '.j2', '.toml', '.ini', '.env', '.css', '.scss',
  '.xml', '.graphql', '.rs', '.go', '.java', '.rb', '.php', '.r', '.lua',
]);

const IMAGE_EXTENSIONS = new Set(['.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg', '.ico']);
const MARKDOWN_EXTENSIONS = new Set(['.md', '.markdown']);
const HTML_EXTENSIONS = new Set(['.html', '.htm']);
const CSV_EXTENSIONS = new Set(['.csv', '.tsv']);
const SPREADSHEET_EXTENSIONS = new Set(['.xlsx', '.xls']);
const PDF_EXTENSIONS = new Set(['.pdf']);

export function getExtension(path = '') {
  const idx = path.lastIndexOf('.');
  return idx >= 0 ? path.slice(idx).toLowerCase() : '';
}

export function detectRendererKind(path, mime = '') {
  const ext = getExtension(path);
  if (MARKDOWN_EXTENSIONS.has(ext) || mime === 'text/markdown') return 'markdown';
  if (HTML_EXTENSIONS.has(ext) || mime === 'text/html') return 'html';
  if (CSV_EXTENSIONS.has(ext) || mime === 'text/csv') return 'csv';
  if (SPREADSHEET_EXTENSIONS.has(ext)) return 'xlsx';
  if (PDF_EXTENSIONS.has(ext) || mime === 'application/pdf') return 'pdf';
  if (IMAGE_EXTENSIONS.has(ext) || (mime || '').startsWith('image/')) return 'image';
  if (CODE_EXTENSIONS.has(ext) || (mime || '').startsWith('text/')) return 'code';
  return 'binary';
}

export function monacoLanguageForPath(path = '') {
  const ext = getExtension(path);
  const map = {
    '.sql': 'sql',
    '.py': 'python',
    '.js': 'javascript',
    '.jsx': 'javascript',
    '.ts': 'typescript',
    '.tsx': 'typescript',
    '.json': 'json',
    '.yml': 'yaml',
    '.yaml': 'yaml',
    '.md': 'markdown',
    '.html': 'html',
    '.css': 'css',
    '.scss': 'scss',
    '.sh': 'shell',
    '.xml': 'xml',
    '.go': 'go',
    '.rs': 'rust',
    '.java': 'java',
    '.rb': 'ruby',
    '.php': 'php',
    '.r': 'r',
    '.toml': 'ini',
    '.ini': 'ini',
  };
  return map[ext] || 'plaintext';
}
